/**
 * Budowa payloadu zapisu konfiguracji platformy CAPI.
 *
 * Wydzielone z komponentu, bo pusty input znaczy tu dwie różne rzeczy i to
 * właśnie na tym rozróżnieniu powstał bug: Test Event Code nie dawał się
 * usunąć — puste pole wypadało z payloadu, backend traktował brak pola jako
 * "nie ruszaj", a UI po zapisie znowu pokazywał starą wartość.
 */

/**
 * Pola-sekrety: nigdy nie wracają z API do formularza, więc pusty input jest
 * dla nich stanem domyślnym, a nie decyzją użytkownika. Do skasowania tokenu
 * służy osobny przycisk, który wysyła jawny `null`.
 */
export const CAPI_SECRET_FIELDS: ReadonlySet<string> = new Set([
  "metaAccessToken",
  "tiktokAccessToken",
]);

export type CapiConfigPayload = Record<string, string | null>;

/**
 * Kontrakt wysyłki (zgodny z walidacją w `apps/api/modules/tracking/capi.ts`):
 *  - wartość  → ustaw,
 *  - `null`   → wyczyść kolumnę,
 *  - brak pola → zostaw to, co w bazie.
 */
export function buildCapiConfigPayload(opts: {
  platform: string;
  formData: Record<string, string>;
}): CapiConfigPayload {
  const { platform, formData } = opts;
  const payload: CapiConfigPayload = { platform };

  for (const [key, value] of Object.entries(formData)) {
    if (value === undefined) continue;
    if (value === "") {
      // Sekret pomijamy (zostaje zapisany), zwykłe pole czyścimy jawnym nullem.
      if (!CAPI_SECRET_FIELDS.has(key)) payload[key] = null;
      continue;
    }
    payload[key] = value;
  }

  return payload;
}
